export default "__VITE_ASSET__CqQ4Qy6R__"